export enum UserSearchType {
  PROFILE = 'profile',
  IDENTITY = 'identity',
  USERNAME = 'username'
}
